import { useEffect, useState } from "react";

import { apiRoot } from "../constants";
import { useAuth } from "./useAuth";

const useEvents = () => {
  const [events, setEvents] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { token, authed } = useAuth();

  useEffect(() => {
    setLoading(true);
    const headers = {
      "Content-Type": "application/json",
    };
    if (authed) {
      headers["Authorization"] = `Token ${token}`;
    }
    fetch(`${apiRoot}/events/`, {
      headers,
    })
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then((json) => {
            setEvents(json);
            setError(false);
            setLoading(false);
          });
        } else {
          setError(true);
          setEvents([]);
          setLoading(false);
        }
      })
      .catch((err) => {
        setError(true);
        setEvents([]);
        setLoading(false);
      });
  }, [authed, token]);

  return {
    events,
    error,
    loading,
  };
};

export default useEvents;
